// src/utils/avvisiFatturazione.js
// Avvisi delle richieste di fatturazione (ottobre 2026):
//  • richiesta nuova → a chi le gestisce (titolare, admin e chi ha il permesso «da-fatturare»,
//    con la stessa logica di Abilitazioni: base del ruolo + aggiunte − rimozioni);
//  • richiesta presa in carico, fatturata o annullata dall'amministrazione → al PM che l'ha fatta.
// Un avviso non inviato non blocca mai la richiesta: si registra solo in console.
import { collection, query, where, getDocs, getDoc, doc, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { sezioniUtente } from "./permessiEffettivi";

const SEZIONE = "da-fatturare";

/** Persone che vedono e gestiscono tutte le richieste di fatturazione dell'azienda. */
export async function gestoriFatturazione(orgId) {
  const [uSnap, abSnap] = await Promise.all([
    getDocs(query(collection(db, "users"), where("organizationId", "==", orgId), where("enabled", "==", true))),
    getDoc(doc(db, "abilitazioniSezioni", orgId)),
  ]);
  const ab = abSnap.exists() ? abSnap.data() : {};
  return uSnap.docs.filter(d => {
    const u = d.data();
    if (u.role === "titolare" || u.role === "admin") return true;
    return sezioniUtente(ab, { ruolo: u.ruoloOperativo, uid: d.id }).has(SEZIONE);
  }).map(d => d.id);
}

const scrivi = (userId, orgId, tipo, titolo, testo) => addDoc(collection(db, "notifiche"), {
  userId, orgId, tipo, titolo, testo, letta: false, createdAt: serverTimestamp(),
});

/** Nuova richiesta: avvisa chi fattura (tranne chi l'ha appena fatta). */
export function avvisaChiFattura({ orgId, mittenteUid, titolo, testo }) {
  gestoriFatturazione(orgId)
    .then(ids => Promise.all(ids.filter(id => id !== mittenteUid).map(id => scrivi(id, orgId, "richiesta_fatturazione", titolo, testo))))
    .catch(err => console.warn("Avviso richiesta di fatturazione non inviato:", err?.code || err));
}

/** Cambio di stato deciso dall'amministrazione: avvisa il PM che ha fatto la richiesta. */
export function avvisaRichiedente({ richiesta, orgId, mittenteUid, nuovoStato }) {
  const uid = richiesta?.richiedenteUid;
  if (!uid || uid === mittenteUid) return;
  const testi = {
    in_lavorazione: ["Richiesta di fatturazione presa in carico", "è stata presa in carico dall'amministrazione"],
    fatturata: ["Fattura emessa", "è stata fatturata"],
    annullata: ["Richiesta di fatturazione annullata", "è stata annullata dall'amministrazione"],
  }[nuovoStato];
  if (!testi) return;
  const commessa = `${richiesta.codiceCommessa ? `[${richiesta.codiceCommessa}] ` : ""}${richiesta.projectName || ""}`;
  scrivi(uid, orgId, "richiesta_fatturazione", testi[0], `La richiesta ${richiesta.numero || ""} · ${commessa} ${testi[1]}`)
    .catch(err => console.warn("Avviso al PM non inviato:", err?.code || err));
}
